import script from "./Ubicaciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Ubicaciones.vue?vue&type=script&setup=true&lang=js"

import "./Ubicaciones.vue?vue&type=style&index=0&id=7d7e3d8c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d7e3d8c"]])

export default __exports__